/** Web credential keys (localStorage). */
export const AUTH_TOKEN_KEY = 'authToken'
export const SESSION_SNAPSHOT_KEY = 'sessionSnapshot'
export const STAFF_AUTH_TOKEN_KEY = 'staffAuthToken'

export function getItem(key: string): string | null {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export function setItem(key: string, value: string): void {
  localStorage.setItem(key, value)
}

export function removeItem(key: string): void {
  localStorage.removeItem(key)
}
